module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-greenery-5-ef707a01a772651935b459f2d1c3c9ad.webp";